import React, { useState } from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import Header1 from './Header1';
import Footer from './Footer';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Cont = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post('https://api.bigfresh.in/contact-user', formData);

       toast.success("Message sent successfully!", { position: "top-center" });
    setFormData({ name: '', phone: '', email: '', message: '' });
  } catch (error) {
    console.error('Error while submitting form:', error);
      toast.error("Something went wrong while submitting the form.", { position: "top-center" });

  }
};


  return (
    <>
      <Header1 />

         <div
        className="d-flex flex-column justify-content-center align-items-center text-center position-relative"
        style={{
          height: '400px',
          color: 'white',
          overflow: 'hidden',
          padding: '0 20px', 
        }}
      >
  
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url('https://plus.unsplash.com/premium_photo-1664527305901-a3c8bec62850')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.4, 
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />

        {/* Content above the overlay */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 className="fw-bold text-black">Contact Us</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ backgroundColor: 'transparent', paddingLeft: 0, marginBottom: 0 }}>
              <li className="breadcrumb-item">
                <a href="/" className="text-black text-decoration-none">
                  <i className="bi bi-house-fill "></i> Home
                </a>
              </li>
              <li className="breadcrumb-item active text-black" aria-current="page">
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container my-5">
        {/* Contact Info Cards */}
        <div className="row text-center g-4 mb-5">
          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 p-4">
              <FaEnvelope size={50} className="text-success mb-3" />
              <h5 className="fw-bold">Email Us</h5>
              <p className="text-muted">info@bigfresh.in</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 p-4">
              <FaPhoneAlt size={50} className="text-success mb-3" />
              <h5 className="fw-bold">Make a Call</h5>
              <p className="text-muted">+91 8755901970</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 p-4">
              <FaMapMarkerAlt size={50} className="text-success mb-3" />
              <h5 className="fw-bold">Address</h5>
              <p className="text-muted">1/11, GIDS, Vapi - 396191 (Gujarat)</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-7">
            <div className="card shadow-sm border-0 p-4">
       
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    className="form-control"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    required
                  />
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-success btn-lg px-5">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Google Map */}
        <div className="ratio ratio-16x9 shadow rounded mb-5">
          <iframe
            title="Big Fresh Mart Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d59847.85783109684!2d72.939852!3d20.362631!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0cf4c403bd075%3A0x74e312d304b597ac!2sGidc%20vapi!5e0!3m2!1sen!2sin!4v1752218679023!5m2!1sen!2sin"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
            <ToastContainer />
      </div>

      <Footer />
    </>
  );
};

export default Cont;


















